<template>
     <base-section id="gallery" space="64">
          <base-section-heading title="Featured Pieces" space="0">
          </base-section-heading>
          <v-container>
               <base-image-gallery :images="images"></base-image-gallery>
          </v-container>
          <v-container>
               <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                         <base-btn
                              color="green"
                              href="https://www.etsy.com/shop/KatinksTrinkets"
                              target="_blank"
                              dark
                         >
                              See More On Etsy
                         </base-btn>
                    </v-col>
               </v-row>
          </v-container>
     </base-section>
</template>

<script>
export default {
     name: 'SectionGallery',
     computed: {},
     data: () => ({
          images: [
               '/assets/images/products/product8_1.jpg',
               '/assets/images/products/product9_1.jpg',
               '/assets/images/products/product1_1.jpg',
               '/assets/images/products/product2_1.jpg',
               '/assets/images/products/product3_1.jpg',
               '/assets/images/products/product4_1.jpg',
               '/assets/images/products/product5_1.jpg',
               '/assets/images/products/product6_1.jpg',
               '/assets/images/products/product7_1.jpg',
               '/assets/images/products/product10_1.jpg',
               '/assets/images/products/product11_1.jpg',
               '/assets/images/products/product12_1.jpg',
               '/assets/images/products/product13_1.jpg',
          ],
     }),
}
</script>
